import React, { useEffect, useState, useRef } from 'react';
import Sales_Afso from './Sales_Afso';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const handleDownload = () => {
    const tableSelect = document.getElementById('distReport');
    if (!tableSelect) return;
    const dataType = 'application/vnd.ms-excel';
    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    downloadLink.download = 'sale_dist.xls';
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

const SaleDistrict_date = async (params) => {
    const response = await fetch(`${process.env.REACT_APP_URL_SALE}/Sale/Sales_Int`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    });
    if (!response.ok) throw new Error('Failed to fetch data');
    return response.json();
};

const Sale_District = ({ month, year }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const [dataTime, setDataTime] = useState("");
    const detailsRRef = useRef(null);

    const handleDistClick = (m, y, dist_code) => {
        setRenderContentt(null);
        setTimeout(() => {
            setRenderContentt(<Sales_Afso month={m} year={y} dist_code={dist_code} />);
        }, 10);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await SaleDistrict_date({ month, year });
                setTabHeading(response_data.heading);
                const data = response_data.data || [];
                setReportData(data);

                if (data.length > 0) {
                    const dTimeItem = data.find(item => item.data_time || item.DATA_TIME || item.datatime);
                    let dTime = dTimeItem ? (dTimeItem.data_time || dTimeItem.DATA_TIME || dTimeItem.datatime) : "";
                    if (dTime) {
                        try {
                            const date = new Date(dTime);
                            if (!isNaN(date.getTime())) {
                                const day = String(date.getDate()).padStart(2, '0');
                                const monthVal = String(date.getMonth() + 1).padStart(2, '0');
                                const yearVal = date.getFullYear();
                                let hours = date.getHours();
                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                const seconds = String(date.getSeconds()).padStart(2, '0');
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                hours = hours % 12 || 12;
                                const strHours = String(hours).padStart(2, '0');
                                dTime = `${day}-${monthVal}-${yearVal} ${strHours}:${minutes}:${seconds} ${ampm}`;
                            }
                        } catch (e) {
                            dTime = dTime.replace('T', ' ').substring(0, 19);
                        }
                    }
                    setDataTime(dTime);
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [month, year]);

    if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>;
    if (error) return <div className="mainhead" align="center">Internal Error</div>;
    if (reportData.length === 0) return <div className="mainhead" align="center">{tabHeading}</div>;

    //   commodity names across the data 
    const uniqueCommNames = Array.from(new Set(
        reportData[0].commodityList.map(c => c.comm_name_en)
    ));

    //  data for each row and calculate grand totals
    const processedRows = reportData.map(item => {
        const commAggregation = {};
        uniqueCommNames.forEach(name => { commAggregation[name] = { nfsa: 0, state: 0 }; });

        item.commodityList.forEach(c => {
            if (commAggregation[c.comm_name_en]) {
                commAggregation[c.comm_name_en].nfsa += Number(c.nfsasaleQty || 0);
                commAggregation[c.comm_name_en].state += Number(c.statesaleQty || 0);
            }
        });

        return { ...item, commAggregation };
    });

    const grandTotals = processedRows.reduce((acc, row) => {
        acc.nfsa_cards += row.nfsa_cards || 0;
        acc.state_cards += row.state_cards || 0;
        acc.total_cards += row.total_cards || 0;
        acc.aay_cards += row.aay_cards || 0;
        acc.phh_cards += row.phh_cards || 0;
        acc.bpl_cards += row.bpl_cards || 0;
        acc.totalNFSA_Avail += row.totalOfaay_cardsPhh_cardsBpl_cards || 0;
        acc.nph_cards += row.nph_cards || 0;

        uniqueCommNames.forEach(name => {
            acc.commTotals[name].nfsa += row.commAggregation[name].nfsa;
            acc.commTotals[name].state += row.commAggregation[name].state;
        });
        return acc;
    }, {
        nfsa_cards: 0, state_cards: 0, total_cards: 0, aay_cards: 0, phh_cards: 0, bpl_cards: 0,
        totalNFSA_Avail: 0, nph_cards: 0,
        commTotals: uniqueCommNames.reduce((obj, name) => ({ ...obj, [name]: { nfsa: 0, state: 0 } }), {})
    });

    return (
        <>
            <div style={{ overflowX: 'auto', width: '100%', margin: '0 auto' }}>
                <table align="center" width="98%" border={1} id='distReport' style={{ borderCollapse: 'collapse' }}>
                    <thead>
                        <tr className="tableheader">
                            <td colSpan={12 + (uniqueCommNames.length * 3)}>{tabHeading}</td>
                        </tr>
                        <tr className="tableheader">
                            <td rowSpan="3">Sl No</td>
                            <td rowSpan="3">District</td>
                            <td colSpan="3">Total Cards</td>
                            <td colSpan="7">Availed Cards</td>
                            <td colSpan={uniqueCommNames.length * 3}>Availed Qty (Kgs)</td>
                        </tr>

                        <tr class="tableheader">
                            <td rowSpan="2"> NFSA<br /><font style={{ color: "orange" }}>(A)</font></td>
                            <td rowspan="2">STATE<br /><font style={{ color: "orange" }}>(B)</font></td>
                            <td rowspan="2">Total<br /><font style={{ color: "orange" }}>(C=A+B)</font> </td>
                            <td colspan="4">NFSA</td>
                            <td colspan="1">STATE<br /><font style={{ color: "orange" }}>(E)</font></td>
                            <td rowspan="2">Total<br /> <font style={{ color: "orange" }}>(F=D+E)</font> </td>
                            <td rowspan="2">NFSA   Avail %<br /> <font style={{ color: "orange" }}> (D*100/A)</font></td>
                            <td colSpan={uniqueCommNames.length}>NFSA<br />  <font style={{ color: " orange" }}>(X)</font> </td>
                            <td colSpan={uniqueCommNames.length} >STATE<br />   <font style={{ color: " orange" }}>(Y)</font>   </td>
                            <td colSpan={uniqueCommNames.length}>Total<br />  <font style={{ color: "orange" }}>(Z=X+Y)</font> </td>
                        </tr>

                        <tr className="tableheader">
                            <td>AAY</td><td>PHH</td><td>BPL</td>  <td>Total<br /><font style={{ color: "orange" }}>(D)</font></td>

                            <td>NPH</td>
                            {uniqueCommNames.map(name => <td key={`h1-${name}`}>{name}</td>)}
                            {uniqueCommNames.map(name => <td key={`h2-${name}`}>{name}</td>)}
                            {uniqueCommNames.map(name => <td key={`h3-${name}`}>{name}</td>)}
                        </tr>
                    </thead>
                    <tbody>
                        {processedRows.map((item, index) => (
                            <tr key={item.dist_code}>
                                <td align="center">{index + 1}</td>
                                <td align="left">
                                    <a style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handleDistClick(month, year, item.dist_code)}>
                                        {item.dist_name_en}
                                    </a>
                                </td>
                                <td align="right">{item.nfsa_cards}</td>
                                <td align="right">{item.state_cards}</td>
                                <td align="right">{item.total_cards}</td>
                                <td align="right">{item.aay_cards}</td>
                                <td align="right">{item.phh_cards}</td>
                                <td align="right">{item.bpl_cards}</td>
                                <td align="right">{item.totalOfaay_cardsPhh_cardsBpl_cards}</td>
                                <td align="right">{item.nph_cards}</td>
                                <td align="right">{item.totalOfaay_cardsPhh_cardsBpl_cards + item.nph_cards}</td>
                                <td align="right">{item.nfsaAvgPercentage}</td>

                                {/* NFSA Columns */}
                                {uniqueCommNames.map(name => (
                                    <td key={`nfsa-${name}`} align="right">{item.commAggregation[name].nfsa.toFixed(3)}</td>
                                ))}
                                {/* STATE Columns */}
                                {uniqueCommNames.map(name => (
                                    <td key={`state-${name}`} align="right">{item.commAggregation[name].state.toFixed(3)}</td>
                                ))}
                                {/* Total Columns */}
                                {uniqueCommNames.map(name => (
                                    <td key={`total-${name}`} align="right">{(item.commAggregation[name].nfsa + item.commAggregation[name].state).toFixed(3)}</td>
                                ))}
                            </tr>
                        ))}
                        {/* Totals Row */}
                        <tr className="tableheader" style={{ fontWeight: 'bold' }}>
                            <td colSpan={2} align="right">Total:</td>
                            <td align="right">{grandTotals.nfsa_cards}</td>
                            <td align="right">{grandTotals.state_cards}</td>
                            <td align="right">{grandTotals.total_cards}</td>
                            <td align="right">{grandTotals.aay_cards}</td>
                            <td align="right">{grandTotals.phh_cards}</td>
                            <td align="right">{grandTotals.bpl_cards}</td>
                            <td align="right">{grandTotals.totalNFSA_Avail}</td>
                            <td align="right">{grandTotals.nph_cards}</td>
                            <td align="right">{grandTotals.totalNFSA_Avail + grandTotals.nph_cards}</td>
                            <td align="right">{(grandTotals.totalNFSA_Avail * 100 / grandTotals.nfsa_cards).toFixed(2)}</td>

                            {uniqueCommNames.map(name => <td key={`t1-${name}`} align="right">{grandTotals.commTotals[name].nfsa.toFixed(3)}</td>)}
                            {uniqueCommNames.map(name => <td key={`t2-${name}`} align="right">{grandTotals.commTotals[name].state.toFixed(3)}</td>)}
                            {uniqueCommNames.map(name => <td key={`t3-${name}`} align="right">{(grandTotals.commTotals[name].nfsa + grandTotals.commTotals[name].state).toFixed(3)}</td>)}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div align="center" style={{ marginTop: '10px' }}>
                <button type="button" className="button button2" onClick={handleDownload}>Data to Excel</button>
            </div>
            {dataTime && (
                <div style={{ width: "98%", textAlign: 'right', margin: '10px auto 0', fontWeight: 'bold' }}>
                    Last Refresh Time: {dataTime}
                </div>
            )}
            <br />

            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default Sale_District;